import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Loader from './Loader';
import Breadcrumb from './Breadcrumb';
import Navbar from './Navbar';
import NavbarAuth from './NavbarAuth';
import NavbarSesion from './NavbarSesion';
import Footer from './Footer';

const Layout = ({ children }) => {

    const { isAuthenticated } = useSelector(state => state.auth);
    const loaderCount = useSelector(state => state.loader.count);

    const location = useLocation();

    const loading = loaderCount > 0;

    const layoutAdmin = (
        <Fragment>
            {loading && <Loader></Loader>}
            <NavbarSesion></NavbarSesion>
            <section className="container-fluid principal-section">
                <Breadcrumb />
                { children }
            </section>
            <a
                href="https://wa.me/524422971928"
                target="_blank"
                rel="noreferrer"
                title="Contáctanos por WhatsApp"
                style={{
                    position: 'fixed',
                    bottom: '28px',
                    right: '28px',
                    zIndex: 9999,
                    width: '52px',
                    height: '52px',
                    borderRadius: '50%',
                    background: '#25D366',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                    textDecoration: 'none',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.1)'; e.currentTarget.style.boxShadow = '0 6px 18px rgba(0,0,0,0.3)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.25)'; }}
            >
                <i className="bi bi-whatsapp" style={{ color: '#fff', fontSize: '1.6rem', lineHeight: 1 }}></i>
            </a>
        </Fragment>
    );

    const layoutGuest = (
        <Fragment>
            {(location.pathname != '/login' && location.pathname != '/register') ? <Navbar></Navbar> : <NavbarAuth></NavbarAuth>}
            { children }
            {(location.pathname != '/login' && location.pathname != '/register') && <Footer></Footer>}
        </Fragment>
    );

    if(isAuthenticated){
        return layoutAdmin;
    } else{
        return layoutGuest;
    }
}

export default Layout;